module.exports = __webpack_public_path__ + "img/solo.844cd1f9.png";